import {useCallback} from "react";

import {UserComAttribute, UserComCustomAttribute, userComUpdateUserAttributes, userComUserengage} from "@pg-mono/user-com";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useAppSelector} from "../../store/hooks";
import type {IClientPayload} from "../api/for_you_client";

type ParamsType = Partial<Omit<IClientPayload, "regions">>;

export const useForYouUserCom = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const regionIds = modalState?.regions?.map((region) => region.id) ?? [];
    const {data: regionDetails} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    const sendUserComEvent = useCallback(
        (params: ParamsType) => {
            const eventName = "homematch_survey_submitted";
            const userComUserPayload = {
                event_name: eventName,
                [UserComAttribute.EMAIL]: params.email || "",
                ...(params?.phone ? {[UserComAttribute.PHONE_NUMBER]: params.phone} : {}),
                [UserComCustomAttribute.EMAIL_MARKETING_CONSENT]: params?.marketing_consent ? "tak" : "nie",
                [UserComCustomAttribute.PHONE_MARKETING_CONSENT]: params?.marketing_consent ? "tak" : "nie"
            };

            const rooms = params?.rooms ?? null;
            const roomsString = `${rooms?.lower ?? ""}${rooms?.lower && rooms.upper ? ", " : ""}${rooms?.upper ?? ""}`;
            const regionStats = regionDetails?.[0].stats;
            const voivodeship = regionStats?.region_type_voivodeship?.name;
            const city = regionStats?.region_type_city?.name;
            const district = regionStats?.region_type_district?.name;

            userComUpdateUserAttributes(userComUserPayload);
            userComUserengage(`event.${eventName}`, {
                ...userComUserPayload,
                ...(params?.price?.upper ? {homematch_survey_budget: params?.price?.upper} : {}),
                ...(rooms ? {homematch_survey_rooms: roomsString} : {}),
                ...(params?.survey_source ? {homematch_survey_source: PreferencesSurveySource[params.survey_source]} : {}),
                ...(voivodeship ? {homematch_survey_voivodeship: voivodeship} : {}),
                ...(district ? {homematch_survey_district: district} : {}),
                ...(city ? {homematch_survey_city: city} : {})
            });
        },
        [regionDetails]
    );

    return {
        sendUserComEvent
    };
};
import {useCallback} from "react";

import {UserComAttribute, UserComCustomAttribute, userComUpdateUserAttributes, userComUserengage} from "@pg-mono/user-com";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useAppSelector} from "../../store/hooks";
import type {IClientPayload} from "../api/for_you_client";

type ParamsType = Partial<Omit<IClientPayload, "regions">>;

export const useForYouUserCom = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const regionIds = modalState?.regions?.map((region) => region.id) ?? [];
    const {data: regionDetails} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    const sendUserComEvent = useCallback(
        (params: ParamsType) => {
            const eventName = "homematch_survey_submitted";
            const userComUserPayload = {
                event_name: eventName,
                [UserComAttribute.EMAIL]: params.email || "",
                ...(params?.phone ? {[UserComAttribute.PHONE_NUMBER]: params.phone} : {}),
                [UserComCustomAttribute.EMAIL_MARKETING_CONSENT]: params?.marketing_consent ? "tak" : "nie",
                [UserComCustomAttribute.PHONE_MARKETING_CONSENT]: params?.marketing_consent ? "tak" : "nie"
            };

            const rooms = params?.rooms ?? null;
            const roomsString = `${rooms?.lower ?? ""}${rooms?.lower && rooms.upper ? ", " : ""}${rooms?.upper ?? ""}`;
            const regionStats = regionDetails?.[0].stats;
            const voivodeship = regionStats?.region_type_voivodeship?.name;
            const city = regionStats?.region_type_city?.name;
            const district = regionStats?.region_type_district?.name;

            userComUpdateUserAttributes(userComUserPayload);
            userComUserengage(`event.${eventName}`, {
                ...userComUserPayload,
                ...(params?.price?.upper ? {homematch_survey_budget: params?.price?.upper} : {}),
                ...(rooms ? {homematch_survey_rooms: roomsString} : {}),
                ...(params?.survey_source ? {homematch_survey_source: PreferencesSurveySource[params.survey_source]} : {}),
                ...(voivodeship ? {homematch_survey_voivodeship: voivodeship} : {}),
                ...(district ? {homematch_survey_district: district} : {}),
                ...(city ? {homematch_survey_city: city} : {})
            });
        },
        [regionDetails]
    );

    return {
        sendUserComEvent
    };
};
